import { useMemo } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { setPage } from '../../../services/auctions/liveAuctionsSlice';
import { useGetLiveAuctionVehiclesQuery } from 'services/api/live-auction';

const StyledButton = styled(Button)`
  && {
    min-width: auto;
    min-height: auto;
    width: 30px;
    height: 30px;
    margin: 2px 4px;
    font-size: 12px;
    line-height: 1;
  }
`;

const StyledPagination = styled.div`
  padding: 38px 0;
  text-align: center;
`;

const VehiclesPaginationFC = () => {
  const dispatch = useDispatch();

  const { page, perPage, filters } = useSelector(state => state.liveAuctions);
  const { data, isFetching, isLoading } = useGetLiveAuctionVehiclesQuery({
    limit: perPage,
    offset: (page - 1) * perPage,
    ...filters
  });

  const auctionLoading = useSelector(state => state.auctions.loading);
  const count = useMemo(() => data?.count ?? 0, [data]);

  const renderButton = (key, label) => {
    return (
      <StyledButton
        variant={page === key ? 'contained' : 'outlined'}
        size="small"
        key={`pb_${key}`}
        color={page === key ? 'primary' : 'default'}
        onClick={() => {
          dispatch(setPage(key));
        }}
      >
        {label}
      </StyledButton>
    );
  };

  const totalPages = Math.ceil(count / perPage);
  const buttons = [];
  if (totalPages < 10) {
    for (let i = 1; i <= totalPages; i += 1) {
      buttons.push(renderButton(i, i));
    }
  } else {
    buttons.push(renderButton(1, 1));
    buttons.push(renderButton(2, 2));
    if (page > 4) {
      buttons.push(renderButton(page - 2, '...'));
    }
    if (page > 3 && page < totalPages) {
      buttons.push(renderButton(page - 1, page - 1));
    }
    if (page > 2 && page < totalPages - 1) {
      buttons.push(renderButton(page, page));
    }
    if (page > 1 && page < totalPages - 2) {
      buttons.push(renderButton(page + 1, page + 1));
    }
    if (page < totalPages - 3) {
      buttons.push(renderButton(page + 2, '...'));
    }
    for (let i = totalPages - 1; i <= totalPages; i += 1) {
      buttons.push(renderButton(i, i));
    }
  }

  if (isFetching || isLoading || auctionLoading) return null;

  return <StyledPagination>{buttons}</StyledPagination>;
};

export default VehiclesPaginationFC;
